export default __webpack_public_path__ + "static/media/Axiforma-Bold.179a2453.ttf";